import script from "./base-loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-loading.vue?vue&type=script&setup=true&lang=ts"

import "./base-loading.vue?vue&type=style&index=0&id=62f49e4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f49e4a"]])

export default __exports__